<aside class="app-sidebar" style="overflow-y: scroll;">
  <div class="main-sidebar-header p-0" id="logo-part">
    <a class="logo logo-light ps-2 text-center" routerLink="/dashboard">
      <span class="logo-lg">
        <img id="logo" name="logo" src="./assets/img/white-logo.png" class="main-sidebar-logo">
        <h3 class="mt-3 ml-4 pl-2 fw-bolder text-nowrap text-white-501 logo-title-head title_clssMenu">XEDGE
          <!-- <span id="pni-text" name="pni-text">Private Network
            Intelligence</span> -->
            
        </h3>
      </span>
    </a>
    <button class="bg-transparent border-0" style="margin-left: auto;" (click)="handleCollapse(sidebarCollapsed)" ><fa-icon  [icon]="sidebarCollapsed?faAngleDoubleRight:faAngleDoubleLeft" ></fa-icon></button>
  </div>
  <div class="main-sidebar-body circle-animation" id="content-part"  (mouseover)="hoverEffect($event,1)" (mouseout)="hoverEffect($event,2)">
    <ul class="side-menu circle">
      <!-- 1st level Menu  -->
      <li class="slide" *ngFor="let menuItem of menuItems" id="mainmenu-{{menuItem.title}}" name="mainmenu-{{menuItem.title}}"
        [ngClass]="{ active: menuItem.active ,'is-expanded': menuItem.active}">
        <ng-container *ngIf="menuItem.headTitle">
          <h3 id="menu-header-title" name="menu-header-title" class="side-item side-item-category">{{menuItem.headTitle}}</h3>
        </ng-container>
        <!-- single link -->
     <a class="side-menu__item" id="mainmenu-{{menuItem.title}}" name="mainmenu-{{menuItem.title}}"
          [ngClass]="(isEmptyObj==false && menujsonlist[menuItem.roleRight]==false) ? 'hide_link' :''"
          [class.disabled]="menuItem.path =='' || menuItem.path =='/'"
           
          *ngIf="menuItem.type === 'link' && menuItem.title !='Edge'" (click)="toggleNavActive(menuItem)">
          <div class="side-menu__icon">
            <i class="material-icons-two-tone {{menuItem.icon}}"></i>
          </div>
          <span  class="side-menu__label">{{menuItem.title}}</span>
          <span class="{{menuItem.status}}"></span>
          <span class="badge badge-{{menuItem.badgeType}} side-badge">{{menuItem.badgeValue}}</span>
        </a>
          <!--parent link link dropdown head -->
       <a class="side-menu__item" id="mainmenu-{{menuItem.title}}"
          [ngClass]="(isEmptyObj==false && menujsonlist[menuItem.roleRight]==false) ? 'hide_link' :''"
         *ngIf="menuItem.type === 'sub'"
          (click)="toggleNavActive(menuItem)">
          <div class="side-menu__icon">
            <i class="material-icons-two-tone {{menuItem.icon}}"></i>
          </div>
          <span class="side-menu__label">{{menuItem.title}}</span>
          <span class="badge badge-{{menuItem.badgeType}} side-badge mr-16">{{menuItem.badgeValue}}</span>
          <i class="angle fe fe-chevron-down"></i>
        </a>
       <!--parent link with child link -->
        <ul class="slide-menu" *ngIf="menuItem.children">
          <li class="sub-slide" *ngFor="let childrenItem of menuItem.children" id="submenu-{{childrenItem.title}}" name="submenu-{{childrenItem.title}}"
            [ngClass]="{'is-expanded': childrenItem.active }">
            <!-- link of parent -->
         <a class="slide-item" [ngClass]="{ active: childrenItem.active}" id="submenu-{{childrenItem.title}}"
              [ngClass]="(isEmptyObj==false && menujsonlist[childrenItem.roleRight]==false) ? 'hide_link' :''"
              *ngIf="childrenItem.type === 'link' && childrenItem.read " (click)="toggleNavActive(childrenItem)">
              {{childrenItem.title}}
              <span class="{{childrenItem.status}}"></span>
            </a>
              <!-- link of parent with new tab open link -->
            <!-- <a class="slide-item" routerLinkActive="active" id="submenu-{{childrenItem.title}}" name="submenu-{{childrenItem.title}}"
              [ngClass]="(isEmptyObj==false && menujsonlist[childrenItem.roleRight]==false) ? 'hide_link' :''"
              *ngIf="childrenItem.type === 'newWindow' " (click)="openNewWindow(childrenItem)">
              {{childrenItem.title}}
            </a> -->
          </li>
        </ul>
      </li>
    </ul>
    <div id="version" class="d-flex justify-content-center" style="margin: 23px 10px 27px;flex-direction: column;">
      <span style="width: 100%; text-align: center; font-size: 14px;">Version {{versionNo}}</span>
      <span  style="width: 100%; text-align: center; font-size: 14px;">{{deploymentName}}</span>
    </div>
  </div>
</aside>
<!-- main-sidebar -->